module.exports = __webpack_public_path__ + "assets/img/serve9.306f9a29.png";